module.exports = __webpack_public_path__ + "img/仙茅.9b2e4915.jpg";